// @lib-generic-ui

import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

const SlugInput = ({value, setValue}) => {
  
  const [error, setError] = useState(false);

  // Validation pattern for a slug: only lowercase letters, numbers, and hyphens
  const slugPattern = /^[a-z0-9-]*$/;

  const handleChange = (event) => {
    const inputValue = event.target.value;
    if (slugPattern.test(inputValue)) {
      setValue(inputValue);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <Box component="form" noValidate autoComplete="off">
      <TextField
        label="Slug"
        variant="outlined"
        value={value}
        onChange={handleChange}
        error={error}
        helperText={error ? "Only lowercase letters, numbers, and hyphens are allowed." : ""}
        fullWidth
      />
    </Box>
  );
};

export default SlugInput;